register('hero-slider', {
  onLoad() {
    const rowsSlider = this.container.querySelector('[tiny-slider]');
    this._heroSlider(rowsSlider);
    const slides = this.container.querySelectorAll('.hp-hero-slide');
    const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (winWidth >= 768) {
      slides.forEach(slide => {
        new ResponsiveAutoHeight(slide.querySelectorAll('.js-auto-height'));

        let text_content = slide.querySelector('.hp-hero__text-inner');
        let button_control = slide.querySelector('.tns-controls--customize');
        if (text_content && button_control) {
          button_control.style.top = text_content.offsetHeight + 'px';
        }
      });
    }
    window.addEventListener('resize', function(event) {
      const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      slides.forEach(slide => {
        const iframe = slide.querySelector('iframe');
        if (iframe) {
          if (winWidth < 768) {
            iframe.style.height = `${slide.offsetHeight}px`;
            iframe.style.width = `${slide.offsetHeight/9.0*16}px`;
          } else {
            if(winWidth / slide.offsetHeight > 16 / 9) {
              iframe.style.width = `${winWidth}px`;
              iframe.style.height = `${winWidth/16.0*9}px`;
            } else {
              iframe.style.height = `${slide.offsetHeight}px`;
              iframe.style.width = `${slide.offsetHeight/9.0*16}px`;
            }
          }
        }
      });
    }, true);
  },
  _heroSlider(rowsSlider){
    if (!rowsSlider) { return; }
    const self = this;
    const heroSlider = tns({
      container: rowsSlider,
      items: 1,
      slideBy: 1,
      gutter: 0,
      center: false,
      autoplay: false,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      mouseDrag: true,
      autoHeight: true,
      startIndex: 0,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          controls: false,
          mouseDrag: false,
          autoHeight: false,
        }
      }
    });
    const coltrol_btns = rowsSlider.querySelectorAll('.tns-controls--customize button');
    coltrol_btns.forEach(btn => {
        btn.addEventListener('click', (e) =>{
            if (btn.getAttribute('data-controls') == 'prev') {
                heroSlider.goTo('prev');
            }else{
                heroSlider.goTo('next');
            }
        })
    });

    heroSlider.events.on('indexChanged', function(info,eventName){
      let indexPrev = info.slideItems[info.indexCached].getAttribute('data-slide'),
      indexCurrent = info.slideItems[info.index].getAttribute('data-slide'),
      prevSlide = info.slideItems[info.indexCached],
      currentSlide = info.slideItems[info.index],
      all_videos = self.container.querySelectorAll('.youtube-video,.vimeo-video,video'),
      videos = currentSlide.querySelectorAll('.youtube-video,.vimeo-video,video');

      all_videos.forEach(video => {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause();
        } else if( video.classList.contains('youtube-video') ) {
          video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
      });
      videos.forEach(video => {
        if (video.tagName.toLowerCase() === 'video') {
          video.play();
        } else if( video.classList.contains('youtube-video') ) {
          video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }
      });

      /*
      let text_content = currentSlide.querySelector('.hp-hero__text-inner');
      let button_control = currentSlide.querySelector('.tns-controls--customize');
      if (text_content && button_control) {
        button_control.style.top = text_content.offsetHeight + 'px';
      }
      */
    });

    heroSlider.events.on('newBreakpointEnd', function(info, eventName){
        heroSlider.updateSliderHeight()
    });
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});

load('hero-slider');